export const formatCurrency = (symbol: string, value: number): string => {
  return `${symbol} ${addDotsToNumber(value)}`;
};

export const formatCurrencyWithK = (symbol: string, value: number): string => {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return value >= item.value;
    });
  return item
    ? `${symbol} ${(value / item.value).toFixed(0).replace(rx, '$1')} ${
        item.symbol
      }`
    : '0';
};

export const addDotsToNumber = (value: number): string => {
  if (isNaN(value)) {
    return '';
  }
  const formatter = new Intl.NumberFormat();
  return `${formatter.format(value).replace(/,/gi, '.')}`;
};

export const intPositiveNumber = (value: string): number =>
  Math.abs(parseInt(value, 10));
